import * as devisConf from '@/configuration/devisConf';
import getLibellesEcheancier from '@/services/commande/echeancierFacturation/getLibellesEcheancier';
import formatDate from '@/services/general/formatDate';
import moment from 'moment';

export default function validation(response, messages, lignesCommande, type) {
  if (!response.data.error || !response.data.error.validationErrors) {
    return;
  }
  let i18nType = '';
  switch (type) {
    case devisConf.TYPE_COMMANDE:
      i18nType = 'validationCommande';
      break;
    case devisConf.TYPE_DEVIS:
      i18nType = 'validationDevis';
      break;
    default:
      i18nType = '';
      break;
  }

  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('ECHEANCIER_LIGNE_END_DATE_NOT_BE_LESS_THAN_START_DATE') === 0) {
      const elements = message.split('|')[0].split('@');
      const libelles = getLibellesEcheancier(elements[1], lignesCommande);
      let libelle = '';
      let trad = '';
      if (libelles.length > 1) {
        libelle = libelles.map(l => {
          return ' - ' + l.libelleProduit + (l.libellePatri ? `:   ${l.libellePatri}` : '');
        }).join('\n');
        trad = 'Multi';
      } else {
        libelle = libelles[0].libelleProduit + (libelles[0].libellePatri ? `: \t ${libelles[0].libellePatri}` : '');
      }
      messages.push({
        message: i18nType + '.dateFinEcheancierLigneNotBeLessThanDateDebut' + trad,
        parametres: {
          libelle: libelle,
          dateDebut: formatDate(moment(elements[2], 'DD/MM/YYYY')),
        },
      });
    }
  });
}
